export default {
	namespaced: true,
	state: {
		list: []
	},
	getters: {
		getList: state => {
			return state.list
		}
	},
	mutations: {
		addToList (state, news) {
			state.list.push(news);
		},
		setList (state, newsList) {
			state.list = newsList;
		}
	},
	actions: {
		addToList: function ({ commit }, news) {
			return commit('addToList', news)
		},
		setList: function ({ commit }, newsList) {
			return commit('setList', newsList)
		}
	}
}
